<template>
    <div class="app-page-wrapper">
        <slot></slot>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AppPageWrapper',
});
</script>

<style lang="scss" scoped>
.app-page-wrapper {
    position: relative;
    display: flex;
    overflow: hidden;
    flex: 1;
    flex-direction: column;
    background: #fafafa;
}
</style>
